import React, { memo, useEffect, useState } from 'react'
import LineChart from 'app/components/Charts/LineChart'
import Spinner from 'app/components/Spinner'
import { getTimelineLikes } from 'app/api/reports'
import { format, parseISO } from 'date-fns'

const options = [
  {
    border: '#3282b8',
    background: 'rgba(50, 130, 184, 0.8)',
    label: 'Curtidas em  publicações',
    variable: 'likes'
  }
]

const TimelineLikes = ({ filter }) => {
  const [labels, setLabels] = useState([])
  const [datasets, setDatasets] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (Boolean(filter.startDate) && Boolean(filter.endDate)) {
      setLoading(true)
      getTimelineLikes(filter).then(response => {
        if (!response.data || !response.data.length) {
          return false
        }

        setLabels(
          response.data.map(dataset => {
            return format(parseISO(dataset.date), 'dd/MM/yyyy')
          })
        )

        setDatasets(
          options.map(option => ({
            label: option.label,
            borderWidth: 1,
            borderColor: option.border,
            backgroundColor: option.background,
            data: response.data.map(data => data[option.variable])
          }))
        )

        setLoading(false)
      })
    }
  }, [filter])

  if (loading) {
    return <Spinner />
  }

  return (
    <LineChart
      id={'chart-bar-timeline-likes'}
      label={''}
      labels={labels}
      datasets={datasets}
    />
  )
}

export default memo(TimelineLikes)
